import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'sd-no-payments',
  templateUrl: './no-payments.component.html',
  styleUrls: ['./no-payments.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdvorNoPaymentsComponent {
  @Output() addPayment = new EventEmitter<void>();
}
